import React from 'react';
import TourHero from './TourHero';
import TourGallery from './TourGallery';
import TourInfo from './TourInfo';
import TourCta from './TourCta';
import './TourMain.scss';

const TourMain = () => {
  return (
    <>
      <TourHero />
      <TourGallery />
      <TourInfo />
      <TourCta />
    </>
  );
};


export default TourMain;
